export default __webpack_public_path__ + "static/media/itrade_logo.733112e5.png";